import { QuillEditor } from "@pathwright/blocks/src/shared"
import Button from "@pathwright/ui/src/components/button/Button"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import PropTypes from "prop-types"
import { useRef } from "react"
import { FeedbackContainer } from "./ui"

export const getFeedback = (feedbackList) => {
  return feedbackList ? feedbackList[0] : null
}

const htmlToFeedback = (feedbackList, html) => {
  const feedback = getFeedback(feedbackList)
  return feedback ? { ...feedback, html } : { html, showCondition: "ALWAYS" }
}

const FeedbackEdit = ({ feedbackList, onChange, instructionText }) => {
  const handleClearFeedback = () => {
    onChange({ feedback: null })
  }

  const handleChange = (html) => {
    const feedback = htmlToFeedback(feedbackList, html)
    onChange({ feedback: [feedback] })
  }

  const feedback = getFeedback(feedbackList)
  const feedbackNeedsFocus = useRef(!feedback).current

  return (
    <div className="FeedbackEdit">
      {feedback ? (
        <FeedbackContainer>
          <div style={{ width: "100%" }}>
            <QuillEditor
              toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
              html={feedback.html}
              placeholder={"Enter answer explanation"}
              onChange={handleChange}
              autofocus={feedbackNeedsFocus}
            />
          </div>
          <IconButton
            icon="trash"
            onClick={handleClearFeedback}
            className="EditButton"
          />
        </FeedbackContainer>
      ) : (
        <Button
          styleType="blank"
          className="editModeLink"
          onClick={() => handleChange("")}
        >
          {instructionText}
        </Button>
      )}
    </div>
  )
}

FeedbackEdit.defaultProps = {
  instructionText: "Add an answer explanation"
}

FeedbackEdit.propTypes = {
  feedbackList: PropTypes.arrayOf(PropTypes.object),
  instructionText: PropTypes.string,
  onChange: PropTypes.func
}

export default FeedbackEdit
